import common from '../_common/actions';
import ActionTypes from '../../constants/ActionTypes';
import Select from '../Select';
var add = common.add(ActionTypes.SELECTIONS);
var setActiveKey = common.setActiveKey(ActionTypes.SELECTIONS);
var updateStateFromView = common.updateSubstateFromView(ActionTypes.SELECTIONS);

var setActiveSelectionFeatureKeysFilterKeys = function setActiveSelectionFeatureKeysFilterKeys(selectionKeys) {
  return function (dispatch, getState) {
    var activeSelectionKey = Select.selections.getActiveKey(getState());

    if (activeSelectionKey && selectionKeys) {
      dispatch(setFeatureKeysFilterKeys(activeSelectionKey, selectionKeys));
    }
  };
};

var updateStateFromViewWithData = function updateStateFromViewWithData(view) {
  return function (dispatch) {
    dispatch(updateStateFromView(view));

    if (view.data) {
      dispatch(add(view.data));
    }
  };
}; // ============ actions ===========


function clearFeatureKeysFilter(key) {
  return {
    type: ActionTypes.SELECTIONS.CLEAR.FEATURE_KEYS_FILTER,
    key: key
  };
}

function setFeatureKeysFilterKeys(key, featureKeys) {
  return {
    type: ActionTypes.SELECTIONS.SET.FEATURE_KEYS_FILTER.KEYS,
    key: key,
    featureKeys: featureKeys
  };
}

export default {
  add: add,
  clearFeatureKeysFilter: clearFeatureKeysFilter,
  setActiveSelectionFeatureKeysFilterKeys: setActiveSelectionFeatureKeysFilterKeys,
  setActiveKey: setActiveKey,
  setFeatureKeysFilterKeys: setFeatureKeysFilterKeys,
  updateStateFromView: updateStateFromView,
  updateStateFromViewWithData: updateStateFromViewWithData
};